export const PARTICIPANT_TIMEPOINT_STATES = {
  ALREADY_COMPLETED: "already_completed",
};
